import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/group`,
    name: 'MAINTAIN_GROUP_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
